export default __webpack_public_path__ + "static/loneavdelningen-gora-sitt-4de36c3cbff04191cb64bfbb13864e4c.jpg";